// extracted by mini-css-extract-plugin
module.exports = {"forks":"Forks_forks__9tZMM","forkButton":"Forks_forkButton__2YS5V","forksCount":"Forks_forksCount__bB1el"};